const GET_ANIME_WATCHLIST_STAT_START = 'GET_ANIME_WATCHLIST_STAT_START';
const GET_ANIME_WATCHLIST_STAT_SUCCESS = 'GET_ANIME_WATCHLIST_STAT_SUCCESS';
const GET_ANIME_WATCHLIST_STAT_FAIL = 'GET_ANIME_WATCHLIST_STAT_FAIL';

export {
  GET_ANIME_WATCHLIST_STAT_START,
  GET_ANIME_WATCHLIST_STAT_SUCCESS,
  GET_ANIME_WATCHLIST_STAT_FAIL,
};
